<template>
    <div class="custom-dropzone" :id="id" ref="dropzoneArea">
        <div class="dz-message">
            <p><i class="fa-solid fa-paperclip"></i> Seleccionar adjuntos</p>
            <small>{{ spanText }}</small>
        </div>
    </div>
</template>

<script>
import Dropzone from "dropzone";

export default {
    name: 'dropzone-uploader',
    data (){
        return {
            files: [],
            dropzone: null
        }
    },
    props: {
        modelValue: {
            type: Array,
            default: () => []
        },
        spanText: {
            type: String,
            default: "Elige un archivo"
        },
        id: {
            type: String,
            default: "dropzone"
        },
        maxFiles: {
            type: Number,
            default: 1
        },
        acceptedFiles: {
            type: String,
            default: 'image/*'
        },
        showFileContent: {
            type: Boolean,
            default: false
        },
        pasteEvent: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        modelValue (val)  {
            this.files = val
        }
    },
    methods: {
        handlePaste(event) {
            let items = (event.clipboardData || event.originalEvent.clipboardData).items;
            for (let item of items) {
                if (item.kind === "file") {
                    let file = item.getAsFile();
                    if (file) {
                        this.processPastedFile(file);
                    }
                }
            }
        },
        processPastedFile(file) {
            // Agrega el archivo a Dropzone manualmente
            this.dropzone.emit("addedfile", file);

            if (file.type.startsWith("image/")) {
                 // Generar una URL de objeto para la imagen
                const imageUrl = URL.createObjectURL(file);
                // Emitir el thumbnail directamente con la URL generada
                this.dropzone.emit("thumbnail", file, imageUrl);
            } else if (file.type === 'application/pdf') {
                if (this.showFileContent) this.renderFileContent(file);
            }
            this.dropzone.emit("complete", file);
            this.files.push(file);
            this.$emit("update:modelValue", this.files);
        },
        initializeDropzone() {
            this.dropzone = new Dropzone(`#${this.id}`, {
                url: "/upload", // Cambia por la URL de tu endpoint
                maxFilesize: 5, // Tamaño máximo del archivo (en MB)
                acceptedFiles: this.acceptedFiles, // Tipos de archivo permitidos
                addRemoveLinks: true, // Para permitir eliminar archivos de la vista
                autoProcessQueue: false,
                dictRemoveFile: "Remover",
                maxFiles: this.maxFiles,
                resizeMimeType: 'image/jpeg'
            });

            // Evento que se dispara cuando se agrega un archivo
            this.dropzone.on("addedfile", (file) => {
                // Emitir el nuevo array de archivos al componente padre
                if (this.showFileContent) this.renderFileContent(file)
                this.files.push(file)
                this.$emit("update:modelValue", this.files);
            });

            // Evento que se dispara cuando se elimina un archivo
            this.dropzone.on("removedfile", (file) => {
                // Eliminar el archivo del array y emitir el nuevo valor
                this.files = this.files.filter(item => item.name !== file.name);
                this.$emit("update:modelValue", this.files);
            });
        },
        renderFileContent(file) {
            if (file.type === "application/pdf") {
                const previewElement = file.previewElement;

                if (previewElement) {
                    const dzImage = previewElement.querySelector('.dz-image');
                    if (dzImage) dzImage.remove();

                    const dzDetails = previewElement.querySelector('.dz-details');
                    if (dzDetails) dzDetails.remove();

                    const container = document.createElement('div');
                    container.className = 'file-container';

                    const icon = document.createElement('div');
                    icon.className = 'file-icon'
                    icon.innerHTML = '📄';

                    const name = document.createElement('p');
                    name.textContent = file.name;
                    name.className = 'file-name';
                    name.title = file.name;

                    container.appendChild(icon);
                    container.appendChild(name);

                    const removeLink = previewElement.querySelector('.dz-remove');
                    if (removeLink) {
                        previewElement.insertBefore(container, removeLink);
                    } else {
                        previewElement.appendChild(container);
                    }
                }
            }
        },
    },
    mounted() {
        this.initializeDropzone();
        if (this.pasteEvent) this.$refs.dropzoneArea.addEventListener("paste", this.handlePaste);
        this.$refs.dropzoneArea.focus();
    },
    beforeUnmount() {
        if (this.pasteEvent) this.$refs.dropzoneArea.removeEventListener("paste", this.handlePaste);
    }
}

</script>

<style>
.dz-complete img {
    width: 120px;
    height: 120px;
    object-fit: scale-down;
    border-radius: 15px;
}
</style>